module.exports = __webpack_public_path__ + "img/DirhamWhite.ab9c5148.svg";